import { createFileRoute } from '@tanstack/react-router'

import PageProfile from '@/pages/PageProfile'

export const Route = createFileRoute('/profile')({
  component: PageProfile
})
